<script>
	import Modal from './modal.svelte'
	import { onMount } from 'svelte'

	export let loginLinks = jQuery('.account-link') //defined prop in common.js

	const { ajaxUrl, loadingMessage, lostPassUrl } = window.login_form_object

	let securityToken = false
	let shown = false
	let username = ''
	let email = ''
	let firstName = ''
	let lastName = ''
	let password = ''
	let status = false
	let disabledForm = false
	let redirectUrl = '/account/'
	let register = false

	let logo = modal_object.logoSrc

	// refs
	let usernameField
	let firstNameField

	const showModal = () => {
		shown = true
		// focus on username
		setTimeout(() => usernameField.focus(), 20)
		// get security token
		if (!securityToken) {
			jQuery.get('/wp-json/flp-api/v1/get-token').done(function(res) {
				if (res) {
					securityToken = jQuery(res).val()
				}
			})
		}
	}
	const hideModal = () => (shown = false)

	// const switchState = newState => {
	// 	status = ''
	// 	register = newState
	// 	setTimeout(() => (newState ? firstNameField : usernameField).focus(), 20)
	// }

	const formSubmit = e => {
		if (disabledForm) {
			return
		}
		e.preventDefault()
		if (!securityToken) {
			status = 'Error checking credentials. Redirecting to login page...'
			setTimeout(() => {
				window.location.href = '/wp-login.php'
			}, 999)
			return
		}
		// disable submit for 1 second
		disabledForm = true
		setTimeout(() => {
			disabledForm = false
		}, 999)
		status = loadingMessage
		let action = 'ajaxlogin'
		// let action = register ? 'ajaxregister' : 'ajaxlogin'
		let data = {
			action,
			username,
			password,
			firstName,
			lastName,
			email,
			security: securityToken,
		}
		jQuery.ajax({
			type: 'POST',
			dataType: 'json',
			url: ajaxUrl,
			data,
			success: data => {
				status = data.message
				if (data.loggedin === true) {
					window.location.href = redirectUrl
					// if (data.redirect_url) {
					// 	// window.location.href = window.location.href
					// } else {
					// 	window.location.reload()
					// }
				}
			},
			error: data => {
				status = 'Error checking credentials. Redirecting to login page...'
				setTimeout(() => {
					window.location.href = '/wp-login.php'
				}, 999)
				return
			},
		})
	}

	onMount(() => {
		loginLinks.on('click', function(e) {
			e.preventDefault()
			if (this.href) {
				redirectUrl = this.href
			}
			showModal()
		})
		// modal hide on escape press
		document.body.addEventListener('keyup', function(e) {
			if (e.keyCode === 27) {
				hideModal()
			}
		})
	})
</script>

{#if shown}
	<Modal width={600} on:close={hideModal}>
		<div class="inner-login-modal-wrap">
			<div class="modal-head">
				<img src={logo} alt="Florida Painters Logo" />
			</div>
			<div class="modal-body">
				<h2 class="sr-only">Log in</h2>
				<form id="login" action="login" method="post" on:submit={formSubmit}>
					{#if status}
						<p class="status">{status}</p>
					{/if}
					<div class="form-input-wrap">
						<label class="sr-only" for="username">Email or Username</label>
						<input
							id="username"
							type="text"
							name="username"
							bind:this={usernameField}
							bind:value={username}
							placeholder="email or username"
							autocomplete="username"
							required />
					</div>
					<div class="form-input-wrap password-wrap">
						<label class="sr-only" for="password">Password</label>
						<input
							id="password"
							type="password"
							name="password"
							bind:value={password}
							placeholder="password"
							required
							autocomplete="current-password" />
					</div>
					<div class="form-submit-wrap paint-btn">

						<input
							type="submit"
							name=""
							value="login"
							disabled={disabledForm} />
					</div>
				</form>
			</div>

		</div>
	</Modal>
{/if}
